import { AbstractControl, ValidationErrors } from "@angular/forms";

export class CustomValidators {

    /**
     * Hier wird geprüft, ob der Wert der übergebenen `AbstractControl` positiv
     * ist. Der Fehler `{ 'positive': true }` wird zurückgegeben, wenn der Wert
     * negativ ist oder keine Zahl eingegeben wurde. `null` wird zurückgegeben,
     * wenn kein Fehler vorliegt und das Formular valide ist.
     * 
     * @see [Angular FormControl](https://angular.io/api/forms/FormControl).
     * @param control Das FormControl
     * @returns ValidationErrors | null Die Validierungsfehler oder null
     */
    public static positive(control: AbstractControl): ValidationErrors | null {
        if (control.value !== undefined && (isNaN(control.value) || control.value < 0)) {
            return { 'positive': true };
        }
        return null;
    }
}
